// 여러 섹션이 같이 쓰는 클래스 묶음

// 섹션 안의 소제목(대문자 라벨 + 밑줄)
export const LABEL = 'text-sm uppercase tracking-[0.2em] text-stone-500 pb-2 border-b border-stone-200';

// 키보드 포커스 표시(마우스 클릭에는 나타나지 않음)
export const FOCUS_RING =
  'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-stone-900';
